"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const NoopEvaluationsClient_1 = require("./NoopEvaluationsClient");
exports.default = (0, react_1.createContext)({
    renderVersion: 0,
    client: NoopEvaluationsClient_1.NoopEvaluationsClient,
});
